import React, { useState } from "react";
import { Button, Col, ProgressBar, Row } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import Arrow from "./svg/Arrow";
import { PlayVideo } from "../../../page/FirstScreen/cardTypeQr/svg";
import VideoModal, { videoLinks } from "./VideoModal";
import { useLocation } from "react-router-dom";
import classNames from "classnames";
import { ModalSlider } from "../..";
import ModalBackThirdStepEdit from "../../modals/modalBackThirdStepEdit";
import ModalBackThirdStep from "../../modals/modalBackThirdStep";
import useQrConfigs from "../../../hooks/useQrConfigs";

const BAR = [33, 50, 77];

function Progress({ handlerBtnNav }) {
  const { pathname } = useLocation();
  const { lang, pageCounter, langHowWorks, getQrLinkSliceId } = useSelector(
    (state) => ({
      lang: state.changeLang.language.nav,
      pageCounter: pathname === "/" ? 1 : state.navigation.pageCounter,
      langHowWorks: state.changeLang.language.cartType.howItWorks,
      getQrLinkSliceId: state.getQrLinkSlice.id,
    }),
    shallowEqual
  );
  const locale = useSelector((state) => state.changeLang.change);
  const {
    entryLocationEdit,
    isTemplateParam,
    pageNumber,
    isGenerator,
    entryLocation,
  } = useCurrentLocation();
  const [showModal, setShowModal] = useState(false);
  const [isModalSlider, setIsModalSlider] = useState(false);
  const [backModalOpen, setBackModalOpen] = useState(false);
  const [backEditModalOpen, setBackEditModalOpen] = useState(false);

  const { isGeneratorConfigsChanged } = useQrConfigs();

  const handleBack = () => {
    if (isGenerator) {
      handlerBtnNav(pageCounter - 1);
      setBackModalOpen(false);
    }
  };
  const handleCreate = () => {
    if (isGenerator) {
      handlerBtnNav(pageCounter - 2);
      setBackModalOpen(false);
    }
  };

  const handleBackUrl = () => {
    const localePath = locale !== "en" ? `/${locale}` : "";
    if (entryLocationEdit) {
      const pageParam = pageNumber ? `?page=${pageNumber}` : "";
      return `${localePath}/entry/${pageParam}`;
    } else if (entryLocation) {
      const currentUrl = location.pathname;
      const match = currentUrl.match(/\/(\d+)(\/|$)/);
      const id = match[1];
      return `${localePath}/qr-code-generator/constructor/${id}/edit`;
    }
    return "#";
  };
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      {isModalSlider && (
        <ModalSlider handleClose={() => setIsModalSlider(false)} />
      )}
      <Row className="my-md-3 align-items-center justify-content-between">
        <Col xs={3} lg={2}>
          {pageCounter !== 1 && !isTemplateParam && (
            <a
              onClick={() => {
                if (entryLocationEdit) {
                  isGeneratorConfigsChanged()
                    ? setBackEditModalOpen(true)
                    : (window.location.href = handleBackUrl());
                } else {
                  getQrLinkSliceId ? setBackModalOpen(true) : handleBack();
                }
              }}
              className="text-capitalize w-75 w-lg-100 fs-7 text-nowrap btn-back btn btn-outline-primary cursor-pointer"
            >
              <Arrow />{" "}
              <span className="d-none d-md-inline cursor-pointer">
                {lang.desktop[0]}
              </span>
            </a>
          )}
        </Col>
        <Col
          xs={6}
          md={4}
          className={classNames("my-4", {
            "mb-0 mb-lg-4": pageCounter === 1,
          })}
        >
          {pageCounter && pageCounter!== 1 ?
            <h1 className="fw-bold text-center mb-2 fs-md-5 fs-7">
              {lang.showStep[pageCounter - 1]}
            </h1>
            :
            <div className="fw-bold text-center mb-2 fs-md-5 fs-7">
              {lang.showStep[0]}
            </div>
          }
          <ProgressBar animated className="progress-height">
            <ProgressBar variant="primary" now={BAR[pageCounter - 1]} key={1} />
            <ProgressBar
              variant="light-primary"
              now={100 - BAR[pageCounter - 1]}
              key={2}
            />
          </ProgressBar>
          {pageCounter === 1 && (
            <div className="text-center d-lg-none">
              <Button
                variant="link"
                className="text-primary fw-bold text-decoration-none fs-7 mt-3"
                onClick={() => {
                  gtag("event", "click_how_work", {
                    site_language: locale,
                  });
                  if (typeof rdt === "function") {
                    rdt("track", "Custom", { customEventName: "click_how_work" });
                  }
                  setIsModalSlider(true);
                }}
              >
                {langHowWorks}
              </Button>
            </div>
          )}
        </Col>
        <Col xs={3} lg={2}>
          {pageCounter === 2 && videoLinks[pathname] && (
            <div>
              <Button
                variant="outline-primary"
                className="w-100 fs-7"
                onClick={handleOpen}
              >
                <span className="me-lg-2 cursor-pointer">
                  <PlayVideo />
                </span>
                <span className="cursor-pointer d-none d-lg-inline">
                  {lang.desktop[8]}
                </span>
              </Button>
              <VideoModal showModal={showModal} handleClose={handleClose} />
            </div>
          )}
          {pageCounter === 1 && (
            <div className="text-end mt-4 d-none d-lg-block">
              <Button
                variant="link"
                className="text-primary fw-bold text-decoration-none text-nowrap mt-2"
                onClick={() => {
                  gtag("event", "click_how_work", {
                    site_language: locale,
                  });
                  if (typeof rdt === "function") {
                    rdt("track", "Custom", { customEventName: "click_how_work" });
                  }
                  setIsModalSlider(true);
                }}
              >
                {langHowWorks}
              </Button>
            </div>
          )}
        </Col>
      </Row>
      <ModalBackThirdStepEdit
        show={backEditModalOpen}
        onHide={() => setBackEditModalOpen(false)}
        onBack={handleBackUrl()}
      />
      <ModalBackThirdStep
        show={backModalOpen}
        onHide={() => setBackModalOpen(false)}
        onCreate={handleCreate}
        onUpdate={handleBack}
      />
    </>
  );
}

export default Progress;
